import { useEffect } from 'react';
import { useSEO } from '../../utils/seo';
import PageHero from './components/PageHero';
import ContactForm from './components/ContactForm';

export default function ContactPage() {
  useSEO({
    title: 'お問い合わせ | まごころヘルパー - 訪問介護のご相談【逗子市】',
    description: '逗子市のまごころヘルパーへのお問い合わせはこちら。訪問介護サービスのご相談、ご質問、資料請求など、お気軽にお問い合わせください。電話:046-876-6471(平日9:00-18:00)。JR東逗子駅徒歩7分、京急逗子葉山駅徒歩2分。',
    keywords: 'お問い合わせ,訪問介護,相談,逗子市,まごころヘルパー,資料請求,電話番号',
    path: '/contact',
    schema: {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "お問い合わせ",
      "description": "まごころヘルパーへのお問い合わせページ。訪問介護サービスのご相談、ご質問をお気軽にどうぞ。",
      "url": `${import.meta.env.VITE_SITE_URL}/contact`
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.observe-animation').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHero />
      <ContactForm />
    </div>
  );
}
